import styled from 'styled-components';
import { StyledModalStepper } from '../styles';

/** Custom styles for sales workflow  */
export const SalesStepWrapper = styled(StyledModalStepper)`
    .advisor-services {
        border-top : 1px solid ${({ theme }) => theme.tableBorderColor};
        border-bottom : 1px solid ${({ theme }) => theme.tableBorderColor};
        .mdc-form-field {
            flex-direction: row-reverse;
            padding: ${({ theme }) => theme.paddings.base} 0;
        }
    }
`;
